/* unplugin-vue-components disabled */import script from "./Study.vue?vue&type=script&setup=true&lang=ts"
export * from "./Study.vue?vue&type=script&setup=true&lang=ts"

import "./Study.vue?vue&type=style&index=0&id=5121f289&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5121f289"]])

export default __exports__